import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-player-layout',
  templateUrl: './player-layout.component.html',
  styleUrls: ['./player-layout.component.css']
})
export class PlayerLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
